import { REMOVE_NOTIFICATIONS_DELAY } from '../../config';
import { notificationsStore } from '../stores/notifications/notificationsStore';
import { logger } from './logger';
export function notifySuccess(message) {
  logger.info(message);
  removeAfterDelay(notificationsStore.addNotification(message, 'success', undefined));
}
export function notifySuccessWithAction(message, action) {
  logger.info(message);
  removeAfterDelay(notificationsStore.addNotification(message, 'success', action));
}
export function notifyFailure(message) {
  logger.error(message);
  removeAfterDelay(notificationsStore.addNotification(message, 'warning', undefined));
}
export function notifyFailureWithAction(message, action) {
  logger.error(message);
  removeAfterDelay(notificationsStore.addNotification(message, 'warning', action));
}
function removeAfterDelay(id) {
  if (REMOVE_NOTIFICATIONS_DELAY > 0) {
    setTimeout(function () {
      notificationsStore.removeNotification(id);
    }, REMOVE_NOTIFICATIONS_DELAY);
  }
}